export function truncateString(str: string, maxSize: number) {
  if (str.length > maxSize) {
    return `${str.substring(0, maxSize - 3)}...`;
  }
  return str;
}

/**
 * Escape regex-sensitive characters
 */
export function escapeRegExp(text = "") {
  return text.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&");
}
